import { depascalize, DropdownOption, getEnumValues } from "sprint-common-web";

export enum LanguageSpecificationCodeSource {
    Code,
    Iso639,
    LaRg
}

export const languageSpecificationCodeSourceDropdownOptions = getEnumValues(LanguageSpecificationCodeSource).map(
    (codeSource: LanguageSpecificationCodeSource): DropdownOption => ({
        key: codeSource.toString(),
        text: depascalize(LanguageSpecificationCodeSource[codeSource])
    })
);
